import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyComponent } from '../../helpers/CanDeactivate/dirty-component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { WorkingHoursService } from '../../features/vendors/services/working-hours.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';

export interface DialogData {
  working_hours: any[]
  branchId: string
}

@Component({
  selector: 'app-working-hours-form',
  templateUrl: './working-hours-form.component.html',
  styles: ``
})
export class WorkingHoursFormComponent extends DirtyComponent {
  loading = false;
  dataLoading = false;
  override formGroup!: FormGroup;
  isSubmitted = false;

  currentWorkingHours!: any[];
  lang = localStorage.getItem('language') || 'ar';

  startTimeMax!: any;
  constructor(override dialogRef: MatDialogRef<WorkingHoursFormComponent>,
    translate: TranslateService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: WorkingHoursService, private datePipe: DatePipe) {
    super(translate);
  }

  ngOnInit(): void {
    this.currentWorkingHours = JSON.parse(JSON.stringify(this.data.working_hours));
    this.buildForm();
    this.currentWorkingHours.map((day) => {
      if (day.is_closed == 0) {
        day.is_opened = true;
      } else {
        day.is_opened = false;
      }
      this.addDays();
    })
    this.workingHours.patchValue(this.currentWorkingHours);
  }
  convert24To12Time(time: any) {
    let hour = (time.split(':'))[0]
    let min = (time.split(':'))[1]
    let part;
    // if (this.lang == 'en') {
    //   part = hour > 12 ? 'PM' : 'AM';
    // } else {
    //   part = hour > 12 ? 'م' : 'ص';
    // }
    min = (min + '').length == 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour + '').length == 1 ? `0${hour}` : `0${hour}`;
    if (hour < 10) {
      `0${hour}`
    }
    return `${hour}:${min} ${part}`
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      workingHours: this.formBuilder.array([])
    })
  }

  hasError(controlName: string, index: number, errorName: string) {
    return (this.workingHours.controls[index] as FormGroup).controls[controlName].hasError(errorName);
  }

  get workingHours(): FormArray {
    return this.formGroup.get("workingHours") as FormArray
  }

  dayControl(): FormGroup {
    return this.formBuilder.group({
      closed_at: [],
      is_closed: [],
      day: [],
      start_at: [],
      is_opened: [],
      startTimeMax: []
    })
  }

  addDays() {
    this.workingHours.push(this.dayControl());
  }

  openCloseDay(index: number) {
    (this.workingHours.controls[index] as FormGroup).controls['start_at'].clearValidators();
    (this.workingHours.controls[index] as FormGroup).controls['closed_at'].clearValidators();
    if (this.workingHours.value[index].is_opened) {
      (this.workingHours.controls[index] as FormGroup).controls['is_closed'].setValue(1);
      (this.workingHours.controls[index] as FormGroup).controls['start_at'].reset();
      (this.workingHours.controls[index] as FormGroup).controls['closed_at'].reset();
      (this.workingHours.controls[index] as FormGroup).controls['start_at'].clearValidators();
      (this.workingHours.controls[index] as FormGroup).controls['closed_at'].clearValidators();
    } else {
      (this.workingHours.controls[index] as FormGroup).controls['is_closed'].setValue(0);
      (this.workingHours.controls[index] as FormGroup).controls['start_at'].setValidators([Validators.required]);
      (this.workingHours.controls[index] as FormGroup).controls['closed_at'].setValidators([Validators.required, Validators.min((this.workingHours.controls[index] as FormGroup).controls['start_at'].value)]);
    }
  }
  
  convertToEnglishTime(arabicTime: string): string {
    // Replace ص (PM) with PM and م (AM) with AM
    return arabicTime
      .replace('م', 'PM')
      .replace('ص', 'AM');
  }

  convertTime(timeStr: any) {
    // Split the input into time and period (AM/PM)
    const [timePart, period] = timeStr.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (period === 'AM' || period === 'ص') {
      if (hours === 12) {
        hours = 0; // Midnight case
      }
    } else if (period === 'PM' || period === 'م') {
      if (hours !== 12) {
        hours += 12; // PM case (except 12 PM)
      }
    }
    return `${hours}:${minutes}`;
  };
  
  saveWorkingHours() {
    // console.log(this.workingHours.value)
    if (this.workingHours.valid) {
      this.workingHours.value.map((day: any) => {
        const startTime = day.start_at;
        const endTime = day.closed_at;

        if (day.is_opened) {
          day.start_at = this.convertTime(startTime);
          day.closed_at = this.convertTime(endTime);
        }
        delete day.is_opened
      })
      this.loading = true;
      let working_hours = {
        working_hours: this.workingHours.value
      }
      this.service.storeWorkingHour(this.data.branchId, working_hours).subscribe((res) => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('workingHours.Store hours have been successfully updated'),
          text: '',
          imageUrl: './assets/images/icons/success.svg',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
      });
    }
  }
}
